import { z } from "zod";

export const startConversationSchema = z.object({
  businessId: z.string().min(1),
  body: z.string().min(1).max(2000),
});

export const sendMessageSchema = z.object({
  body: z.string().min(1).max(2000),
});

export const pollMessagesSchema = z.object({
  since: z.string().min(1), // ISO timestamp
});

export type StartConversationInput = z.infer<typeof startConversationSchema>;
export type SendMessageInput = z.infer<typeof sendMessageSchema>;
export type PollMessagesInput = z.infer<typeof pollMessagesSchema>;
